/**
 * Order status constants
 * Centralized status definitions for consistency
 */
export const ORDER_STATUSES = {
  PARA_FAZER: "Para fazer",
  AGUARDANDO_MATERIAL: "Aguardando Material",
  FEITO: "Feito",
  AGUARDANDO_TRANSPORTE: "Aguardando Transporte",
  OUTRO: "Outro"
};

export const CHECKBOX_STATUSES = {
  CONCLUIDO: "Concluído",
  EM_ABERTO: "Em aberto"
};

export const STATUS_TYPES = {
  SEPARACAO: "separacao",
  PRODUCAO: "producao"
};

/**
 * Get CSS class for status
 */
export const getStatusClass = (status) => {
  switch (status) {
    case ORDER_STATUSES.PARA_FAZER:
      return 'status-para-fazer';
    case ORDER_STATUSES.AGUARDANDO_MATERIAL:
      return 'status-aguardando-material';
    case ORDER_STATUSES.FEITO:
      return 'status-feito';
    case ORDER_STATUSES.AGUARDANDO_TRANSPORTE:
      return 'status-aguardando-transporte';
    case ORDER_STATUSES.OUTRO:
      return 'status-outro';
    default:
      return 'status-default';
  }
};

/**
 * Get display name for status
 */
export const getStatusDisplayName = (status) => {
  return status || 'Desconhecido';
};
